export default {
  run: function run(type, targets) {
    return targets.reduce(function (curr, target) {
      var onTransition = target.onTransition;

      if (typeof onTransition === 'function') {
        return curr.then(function () {
          return onTransition({
            type: type,
            target: target
          });
        });
      } else {
        return curr;
      }
    }, Promise.resolve());
  }
};